export default __webpack_public_path__ + "static/media/wagon-wheel-effect-1.6193293a.gif";